import { useNavigate } from "react-router-dom";
import { Button } from "../index";

/**
 * ButtonBack — botão de navegação "Voltar" baseado no componente Button.
 *
 * @param {string}   [to]      - Rota de destino. Se omitido, usa navigate(-1).
 * @param {string}   [label]   - Texto exibido no botão. Default: "← Voltar".
 * @param {Function} [onClick] - Callback customizado; sobrescreve o comportamento de navegação.
 * @param {object}   props     - Demais props repassados ao Button (size, className, disabled, etc.).
 */
const ButtonBack = ({ to, label = "← Voltar", onClick, ...props }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
      return;
    }
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button variant="ghost" size="medium" onClick={handleClick} {...props}>
      {label}
    </Button>
  );
};

export default ButtonBack;
